export default __webpack_public_path__ + "static/media/discord.0ec6d90b.svg";